import React, {useEffect, useState} from 'react'
import {Header} from "../../../header/Header";
import {useDispatch, useSelector} from "react-redux";
import {useParams, useNavigate, Link} from "react-router-dom";
import 'animate.css';
import {zynity_api, zynity_website} from "../../../../config/external-routes";
import { Button, Modal } from 'react-bootstrap';
import {MemberAccordion} from "./members/MemberAccordion";
import {MembersContainer} from "./members/MembersContainer";
import {getOrganizationTeam} from "../../../../store/user_organizations/teams/team";
import {setRouteSelectedOrgId, setRouteSelectedTeamId} from "../../../../store/routes";
import {Loading} from "../../../ui/loading/Loading";
import {
  getCnAData,
  setData,
  setDatumIdOpen,
  setDatumIdOpenData
} from "../../../../store/user_organizations/teams/tools/connect_and_align";
import './TeamHeaderMainTrax.css';

export const TeamHeader = ({suffixRoute = '', selected_team_id = '', selected_organization_id = ''}: any) => {
  const dispatch = useDispatch();
  const yii_url = zynity_website.yii_website_url;
  let {organization_id, team_id} = useParams();

  if(selected_team_id != '') {
    team_id = selected_team_id
  }

  if(selected_organization_id != '') {
    organization_id = selected_organization_id
  }

  const [showMaintrax, setShowMaintrax] = useState(false);
  const [showOrganizationTab, setShowOrganizationTab] = useState(true);
  const [activeOrgStatement, setActiveOrgStatement] = useState('why');
  const [activeTeamStatement, setActiveTeamStatement] = useState<
    'purpose' | 'valueCreated' | 'recurringDeliverables'
  >('purpose');

  const user_organizations_obj = useSelector((state:any) => state.user_organizations);
  const user_organizations = user_organizations_obj.data?.data
  let organization = user_organizations.filter((item:any) => item.id == organization_id)[0];
  let organization_teams = organization.teams;
  let selected_team = organization_teams.filter((team:any) => team.id == team_id)[0];

  const teamStatementVisible = (key: 'purpose' | 'valueCreated' | 'recurringDeliverables') => {
    if (key === 'purpose') {
      return Boolean(selected_team?.Purpose) && !selected_team?.hide_purpose_in_main_trax;
    }
    if (key === 'valueCreated') {
      return Boolean(selected_team?.ValueCreated) && !selected_team?.hide_value_created_in_main_trax;
    }
    return Boolean(selected_team?.RecurringDeliverables) && !selected_team?.hide_recurring_deliverables_in_main_trax;
  };

  useEffect(() => {
    if (showOrganizationTab) return;
    const order: Array<'purpose' | 'valueCreated' | 'recurringDeliverables'> = [
      'purpose',
      'valueCreated',
      'recurringDeliverables',
    ];
    if (teamStatementVisible(activeTeamStatement)) return;
    const next = order.find((k) => teamStatementVisible(k));
    if (next) setActiveTeamStatement(next);
  }, [showOrganizationTab, selected_team, activeTeamStatement]);

  const navigate = useNavigate();
  const [showParticipantsModal, setShowParticipantsModal] = useState(false);
  const organization_team = useSelector((state:any) => state.organization_team);

  if(organization_team.isLoading === true || organization_team?.data == '') {
    return <Loading />
  }

  let team_services = organization_team.data.services[0];

  const goToYiiTools = (org_id:any, team_id:any) => {
    const form = document.createElement('form');
    form.method = 'post';
    form.action = `${zynity_website.yii_website_url}/userHome/index`;
    const orgIdInput = document.createElement('input');
    orgIdInput.type = 'hidden';
    orgIdInput.name = 'orgId';
    orgIdInput.value = String(org_id);

    const teamIdInput = document.createElement('input');
    teamIdInput.type = 'hidden';
    teamIdInput.name = 'teamId';
    teamIdInput.value = String(team_id);

    const teamActionInput = document.createElement('input');
    teamActionInput.type = 'hidden';
    teamActionInput.name = 'teamAction';
    teamActionInput.value = String("goToTools");

    form.appendChild(orgIdInput);
    form.appendChild(teamIdInput);
    form.appendChild(teamActionInput);
    document.body.appendChild(form);
    form.submit();
    return false
  }

  const handleChangeOrganization = async ({target}:any) => {
    let new_org_id = target.value;
    let organization = user_organizations.filter((item:any) => item.id == new_org_id)[0];

    let first_team = organization.teams[0];
    let new_team_id = first_team.id;

    //Suites available for React Version
    if(first_team.Suite == 'Executive') {
      console.log("Changed?");
      dispatch(setDatumIdOpen(0));
      dispatch(setDatumIdOpenData(undefined));
      navigate(`/organizations/${new_org_id}/teams/${new_team_id}${suffixRoute}`)
      return false
    }

    //Suites available only in Yii version
    return goToYiiTools(new_org_id, new_team_id)
  }

  const handleChangeOrgTeam = ({target}:any) => {
    let new_team_id = target.value;
    let selected_team = organization_teams.find((team:any) => team.id == new_team_id)

    if(selected_team.Suite == 'Executive') {
      dispatch(setDatumIdOpen(0));
      dispatch(setDatumIdOpenData(undefined));
      dispatch( getOrganizationTeam({organization_id, team_id: new_team_id}) );
      dispatch(getCnAData({organization_id, team_id: new_team_id}))
      navigate(`/organizations/${organization_id}/teams/${new_team_id}${suffixRoute}`, {replace: true})
    } else {
      //Suites available only in Yii version
      return goToYiiTools(organization_id, new_team_id)
    }
  }

  const toogleMaintrax = () => {
    if(showMaintrax === true) {
      setShowMaintrax(false);
    } else {
      setShowMaintrax(true);
    }
  }

  const openParticipantsModal = () => {
    setShowParticipantsModal(true)
  }

  const closeParticipantsModal = () => {
    setShowParticipantsModal(false)
  };

  const handleClickFacilitatorLink = (selectedTeamId: string) => {
    const form = document.getElementById(`facilitatorForm${selectedTeamId}`) as HTMLFormElement;
    if (form) {
      form.submit();
    }
  };

  const goToFacilitatorDashboardHandled = (org_id:string, team_id:string) => {
    dispatch(getOrganizationTeam({organization_id:org_id , team_id}) );
    dispatch(setRouteSelectedOrgId(org_id))
    dispatch(setRouteSelectedTeamId(team_id))
    navigate('/facilitator-dashboard')
  }

  return (
    <>
      <Header />
      <div className="row">
        <div className="col-12 mt-0 mb-0 t-lg-4">
          <nav className="navbar navbar-expand-lg  d-flex justify-content-center pt-3" style={{backgroundColor: '#e8e8e8'}}>
            <ul className="orgTeamHeader-navbar d-flex align-items-center">
              {
                organization.image != null &&
                <li className="nav-item mx-2 mt-2 mt-lg-0">
                  <img style={{width: '120px', maxWidth: '120px', padding: 0}} src={zynity_api.download_file + organization.image} alt="Organization Image"/>
                </li>
              }
              <li className="nav-item mx-2 mt-2 mt-lg-0">
                <select className="form-select" style={{fontWeight: 'bold'}} aria-label="Default select example"
                value={organization_id}
                    onChange={handleChangeOrganization}
                >
                  {
                    user_organizations.map((organization:any) => (
                      <option key={organization.id} value={organization.id}>{organization.name}</option>
                    ))
                  }
                </select>
              </li>
              <li className="nav-item mx-2 mt-2 mt-lg-0">
                <select className="form-select" style={{fontWeight: 'bold'}} aria-label="Default select example"
                    value={team_id}
                    onChange={handleChangeOrgTeam}
                >
                  {
                    organization_teams.map((team:any) => (
                      <option key={team.id} value={team.id}>{team.TeamName}</option>
                    ))
                  }
                </select>
              </li>
              <li className="nav-item mx-2 mt-2 mt-lg-0">
                <button type="button" className="btn btn-teal btn-sm rounded-pill"
                    onClick={openParticipantsModal}
                >Participants <span
                  className="badge bg-light text-dark">{selected_team.total_members}</span></button>

                <Modal show={showParticipantsModal} onHide={closeParticipantsModal}>
                  <Modal.Header closeButton>
                    <Modal.Title className='text-muted fs-5'>Participants - Executive Team Team</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <MembersContainer closeModal={closeParticipantsModal} />
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={closeParticipantsModal}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>

              </li>
              <li className="nav-item mx-2 mt-2 mt-lg-0">
                <button type="button" className="btn btn-teal btn-sm rounded-pill" onClick={toogleMaintrax}>Main Trax</button>
              </li>

              {
                selected_team.is_facilitator &&
                <li className="nav-item mx-2 mt-2 mt-lg-0">
                  <img
                    onClick={() => goToFacilitatorDashboardHandled(organization_id, team_id)}
                    data-toggle="tooltip"
                    style={{width: '40px'}}
                    className="team-icons clickable"
                    src={require('../../../../assets/images/FacilitatorIcon.png')}
                    alt="Facilitator Icon"
                  />
                </li>
              }

              {
                selected_team.is_coach &&
                <Link to="/coach">
                  <img src={require('../../../../assets/images/coach_notes_icon.png')} width="40"></img>
                </Link>
              }

            </ul>
          </nav>
        </div>

        <div
          className={`col-12 mt-0 maintrax ${showMaintrax ? 'open mb-5' : 'mb-3'}`}
          aria-hidden={!showMaintrax}
        >
          <div className="main-trax-root">
            <div className="main-trax-sheet">
              <div className="main-trax-ot-switch">
                <div className="main-trax-ot-tabs" role="tablist" aria-label="Main Trax scope">
                  <button
                    type="button"
                    className={`main-trax-ot-tab ${showOrganizationTab ? 'active' : ''}`}
                    onClick={() => setShowOrganizationTab(true)}
                    aria-selected={showOrganizationTab}
                  >
                    Organization
                  </button>
                  <button
                    type="button"
                    className={`main-trax-ot-tab ${!showOrganizationTab ? 'active' : ''}`}
                    onClick={() => setShowOrganizationTab(false)}
                    aria-selected={!showOrganizationTab}
                  >
                    Team
                  </button>
                </div>
                <div className="main-trax-help">
                  <span className="main-trax-help-mark">?</span>
                  <span className="main-trax-help-text">
                    The Organization statements are managed by the organization Administrator (Org Profile). The Team statements are managed by the team Facilitator (Team Profile).
                  </span>
                </div>
              </div>

              <div className="main-trax-panel">
                {showOrganizationTab ? (
                  <div className="main-trax-reading">
                    <div className="main-trax-stmt-nav" role="tablist" aria-label="Organization statements">
                      {organization.why && !organization.hide_why_in_main_trax && (
                        <button
                          type="button"
                          className={`main-trax-stmt-row ${activeOrgStatement === 'why' ? 'active' : ''}`}
                          onClick={() => setActiveOrgStatement('why')}
                        >
                          Why
                        </button>
                      )}
                      {organization.promise && !organization.hide_promise_in_main_trax && (
                        <button
                          type="button"
                          className={`main-trax-stmt-row ${activeOrgStatement === 'promise' ? 'active' : ''}`}
                          onClick={() => setActiveOrgStatement('promise')}
                        >
                          Promise
                        </button>
                      )}
                      {organization.vision && !organization.hide_vision_in_main_trax && (
                        <button
                          type="button"
                          className={`main-trax-stmt-row ${activeOrgStatement === 'vision' ? 'active' : ''}`}
                          onClick={() => setActiveOrgStatement('vision')}
                        >
                          Vision
                        </button>
                      )}
                      {organization.mission && !organization.hide_mission_in_main_trax && (
                        <button
                          type="button"
                          className={`main-trax-stmt-row ${activeOrgStatement === 'mission' ? 'active' : ''}`}
                          onClick={() => setActiveOrgStatement('mission')}
                        >
                          Mission
                        </button>
                      )}
                      {organization.coreValues && !organization.hide_core_values_in_main_trax && (
                        <button
                          type="button"
                          className={`main-trax-stmt-row ${activeOrgStatement === 'coreValues' ? 'active' : ''}`}
                          onClick={() => setActiveOrgStatement('coreValues')}
                        >
                          Core Values
                        </button>
                      )}
                      {organization.cultureStatement && !organization.hide_culture_statement_in_main_trax && (
                        <button
                          type="button"
                          className={`main-trax-stmt-row ${activeOrgStatement === 'cultureStatement' ? 'active' : ''}`}
                          onClick={() => setActiveOrgStatement('cultureStatement')}
                        >
                          Culture Statement
                        </button>
                      )}
                      {organization.valueCreated && !organization.hide_value_created_in_main_trax && (
                        <button
                          type="button"
                          className={`main-trax-stmt-row ${activeOrgStatement === 'valueCreated' ? 'active' : ''}`}
                          onClick={() => setActiveOrgStatement('valueCreated')}
                        >
                          Value Created
                        </button>
                      )}
                    </div>

                    <div className="main-trax-reading-col">
                      {activeOrgStatement === 'why' && organization.why && (
                        <div className="main-trax-reading-copy">
                          <div className="main-trax-reading-context">Organization Statement</div>
                          <h3 className="main-trax-reading-title">Why</h3>
                          <div className="main-trax-reading-body" dangerouslySetInnerHTML={{__html: organization.why}} />
                        </div>
                      )}
                      {activeOrgStatement === 'promise' && organization.promise && (
                        <div className="main-trax-reading-copy">
                          <div className="main-trax-reading-context">Organization Statement</div>
                          <h3 className="main-trax-reading-title">Promise</h3>
                          <div className="main-trax-reading-body" dangerouslySetInnerHTML={{__html: organization.promise}} />
                        </div>
                      )}
                      {activeOrgStatement === 'vision' && organization.vision && (
                        <div className="main-trax-reading-copy">
                          <div className="main-trax-reading-context">Organization Statement</div>
                          <h3 className="main-trax-reading-title">Vision</h3>
                          <div className="main-trax-reading-body" dangerouslySetInnerHTML={{__html: organization.vision}} />
                        </div>
                      )}
                      {activeOrgStatement === 'mission' && organization.mission && (
                        <div className="main-trax-reading-copy">
                          <div className="main-trax-reading-context">Organization Statement</div>
                          <h3 className="main-trax-reading-title">Mission</h3>
                          <div className="main-trax-reading-body" dangerouslySetInnerHTML={{__html: organization.mission}} />
                        </div>
                      )}
                      {activeOrgStatement === 'coreValues' && organization.coreValues && (
                        <div className="main-trax-reading-copy">
                          <div className="main-trax-reading-context">Organization Statement</div>
                          <h3 className="main-trax-reading-title">Core Values</h3>
                          <div className="main-trax-reading-body" dangerouslySetInnerHTML={{__html: organization.coreValues}} />
                        </div>
                      )}
                      {activeOrgStatement === 'cultureStatement' && organization.cultureStatement && (
                        <div className="main-trax-reading-copy">
                          <div className="main-trax-reading-context">Organization Statement</div>
                          <h3 className="main-trax-reading-title">Culture Statement</h3>
                          <div className="main-trax-reading-body main-trax-reading-scroll" dangerouslySetInnerHTML={{__html: organization.cultureStatement}} />
                        </div>
                      )}
                      {activeOrgStatement === 'valueCreated' && organization.valueCreated && (
                        <div className="main-trax-reading-copy">
                          <div className="main-trax-reading-context">Organization Statement</div>
                          <h3 className="main-trax-reading-title">Value Created</h3>
                          <div className="main-trax-reading-body main-trax-reading-scroll" dangerouslySetInnerHTML={{__html: organization.valueCreated}} />
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="main-trax-reading">
                    <div className="main-trax-stmt-nav" role="tablist" aria-label="Team statements">
                      {teamStatementVisible('purpose') && (
                        <button
                          type="button"
                          className={`main-trax-stmt-row ${activeTeamStatement === 'purpose' ? 'active' : ''}`}
                          onClick={() => setActiveTeamStatement('purpose')}
                        >
                          Purpose
                        </button>
                      )}
                      {teamStatementVisible('valueCreated') && (
                        <button
                          type="button"
                          className={`main-trax-stmt-row ${activeTeamStatement === 'valueCreated' ? 'active' : ''}`}
                          onClick={() => setActiveTeamStatement('valueCreated')}
                        >
                          Value Created
                        </button>
                      )}
                      {teamStatementVisible('recurringDeliverables') && (
                        <button
                          type="button"
                          className={`main-trax-stmt-row ${activeTeamStatement === 'recurringDeliverables' ? 'active' : ''}`}
                          onClick={() => setActiveTeamStatement('recurringDeliverables')}
                        >
                          Recurring Deliverables
                        </button>
                      )}
                    </div>
                    <div className="main-trax-reading-col">
                      {activeTeamStatement === 'purpose' && teamStatementVisible('purpose') && (
                        <div className="main-trax-reading-copy">
                          <div className="main-trax-reading-context">Team Statement</div>
                          <h3 className="main-trax-reading-title">Purpose</h3>
                          <div className="main-trax-reading-body" dangerouslySetInnerHTML={{__html: selected_team.Purpose}} />
                        </div>
                      )}
                      {activeTeamStatement === 'valueCreated' && teamStatementVisible('valueCreated') && (
                        <div className="main-trax-reading-copy">
                          <div className="main-trax-reading-context">Team Statement</div>
                          <h3 className="main-trax-reading-title">Value Created</h3>
                          <div
                            className="main-trax-reading-body main-trax-reading-scroll"
                            dangerouslySetInnerHTML={{__html: selected_team.ValueCreated}}
                          />
                        </div>
                      )}
                      {activeTeamStatement === 'recurringDeliverables' && teamStatementVisible('recurringDeliverables') && (
                        <div className="main-trax-reading-copy">
                          <div className="main-trax-reading-context">Team Statement</div>
                          <h3 className="main-trax-reading-title">Recurring Deliverables</h3>
                          <div
                            className="main-trax-reading-body main-trax-reading-scroll"
                            dangerouslySetInnerHTML={{__html: selected_team.RecurringDeliverables}}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}
